import styled, { css } from 'styled-components';
import { CommodityStatusCode } from '@bechtel/types';
import { AvatarStyled } from '@bechtel/gds';

export const WeldCommodityItemStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey[300]};
  border-radius: ${({ theme }) => theme.radii[200]};
  flex-grow: 1;
  margin-bottom: ${({ theme }) => theme.spacings[400]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const CommodityInfoStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacings[400]};
  padding-bottom: ${({ theme }) => theme.spacings[450]};
  padding-left: ${({ theme }) => theme.spacings[600]};
  padding-right: ${({ theme }) => theme.spacings[600]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[500]};
`;

interface WeldStatusIndicatorProps {
  status?: CommodityStatusCode;
  isAssigned?: boolean;
}

const getBackgroundStatusColor = (props: WeldStatusIndicatorProps) => {
  switch (props.status) {
    case CommodityStatusCode.VT_APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.green[200]};
      `;
    case CommodityStatusCode.CLAIMED:
    case CommodityStatusCode.FITUP_INSPECTION:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.orange[200]};
      `;
    case CommodityStatusCode.BLOCKED:
      return css`
        background-color: ${({ theme }) => theme.colors.red[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.red[200]};
      `;
    case CommodityStatusCode.VT_SENT_BACK:
    case CommodityStatusCode.SENT_BACK_TO_PIPING:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.purple[200]};
      `;
    case CommodityStatusCode.READY_TO_WELD: //TODO here it was milestone unclaim so when I changed in CommodityStatusCode made it READY_TO_WELD
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.grey[200]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.grey[200]};
      `;
  }
};

export const WeldStatusContainerStyled = styled.div`
  cursor: pointer;
`;

export const WeldStatusIndicatorStyled = styled.div<WeldStatusIndicatorProps>`
  border-radius: ${({ theme }) => theme.radii[400]};
  height: ${({ theme }) => theme.spacings[700]};
  margin-right: ${({ theme }) => theme.spacings[500]};
  width: ${({ theme }) => theme.spacings[400]};
  ${getBackgroundStatusColor}
`;

export const AddCrewStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.blue[700]};
    border-color: ${theme.colors.bechtel.blue[700]};
  `};
`;
